import React from "react";
import { Table, Title } from "@allxsmith/bestax-bulma";
import { formatDate, readableDate } from "../../utils";

class PrintCustomerServiceRecord extends React.Component {

  PartRow(part) {
    return (
      <tr key={part.id}>
        <td></td>
        <td></td>
        <td>{part.name}</td>
      </tr>
    );
  }

  WorkRow(work) {
    let rows = [];
    rows.push(
      <tr key={work.id} className="table-highlight-orange">
        <td>{readableDate(work.finish_date)}</td>
        <td>{work.description}</td>
        <td></td>
      </tr>
    );
    rows = rows.concat(work.parts.map(part => this.PartRow(part)));
    return rows;
  }

  render() {
    return (
      <div className="print-background">
        <Title>Service Record: {this.props.registration}</Title>
        <Table>
          <thead>
            <tr>
              <td>Date</td>
              <td>Description</td>
              <td>Part Name</td>
            </tr>
          </thead>
          <tbody>
            {Object.entries(this.props.data)
              .sort(
                (a, b) =>
                  new Date(a[1].finish_date) - new Date(b[1].finish_date)
              )
              .map(entry => this.WorkRow(entry[1]))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default PrintCustomerServiceRecord;
